module.exports = __webpack_public_path__ + "img/836000079_4.217c63f3.jpg";